var map = {
	"./StiftungWissenDark.png": 19576,
	"./StiftungWissenLight.png": 63338,
	"./UniBonn.png": 28860,
	"./adaptive-icon.png": 19763,
	"./alice.png": 67327,
	"./arrow.png": 44924,
	"./arrow_white.png": 38970,
	"./bob.png": 24342,
	"./brightness_mask.png": 8279,
	"./color_slider.png": 86432,
	"./favicon.png": 51151,
	"./icon.png": 19812,
	"./profile.png": 50296,
	"./saturation_mask.png": 56156,
	"./splash.png": 762
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97060;